import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';
import { UserApplicationAccess } from '@digital-platform/unified-wp-common-domain';

/**
 * A resolver that determines the user's application access level w.r.t Special Waste and COR.
 * @returns
 */
export const ApplicationAccessResolver: ResolveFn<
  UserApplicationAccess
> = (): UserApplicationAccess => {
  const auraAuthService = inject(AuraAuthService);
  let access: UserApplicationAccess = 'NONE';

  const SPECIAL_WASTE_ACCESS_PERMISSION = 'user:special-waste';
  const COR_ACCESS_PERMISSION = 'user:cor';

  if (auraAuthService.isAuthorized([SPECIAL_WASTE_ACCESS_PERMISSION])) {
    access = 'SW';
  }

  if (auraAuthService.isAuthorized([COR_ACCESS_PERMISSION])) {
    access = access === 'SW' ? 'BOTH' : 'COR';
  }

  return access;
};
